import { User } from '@modules/husleie-framework/src/types/User.entity';
import Address from '@modules/husleie-framework/src/types/Address.entity';

const enum TenantType {
  TENANT = 'tenant',
  COTENANT = 'cotenant',
}

interface Tenant {
  id?: number;
  type?: TenantType;
  status?: string;
  user?: User;
  address?: Address;
}

export { Tenant, TenantType };
